import React from "react";
import PageArticle from "../../components/_template/page/PageArticle";
import PageTitle from "../../components/_molecules/page/PageTitle";
import { KindOfKit } from "../../assets/constant/kit.type";
import "../../styles/TokenizeMain.scss";
import "../../styles/KitList.scss";
import TagBadge, { TagBadgeType } from "./components/TagBadge";
import { useNavigate } from "react-router-dom";
import pointKitImg from "../../assets/images/img_point_kit.png";
import membershipKitImg from "../../assets/images/img_membership_kit.png";
import ticketKitImg from "../../assets/images/img_ticket_kit.png";
import tokenKitImg from "../../assets/images/img_token_kit.png";
import nftKitImg from "../../assets/images/img_nft_kit.png";
import securityKitImg from "../../assets/images/img_security_kit.png";
import DivideLine from "../../components/_atom/line/DivideLine";
import { NETWORKS } from "../../assets/constant/network.constant";

type KitCard = {
  title: string;
  description: string;
  image: string;
  type: KindOfKit;
  tag: string[];
  path?: string;
  isNew?: true;
  supportedNetworkIds: number[];
};
const PRE_CONFIGURED_KITS: KitCard[] = [
  {
    title: "Membership Kit",
    description: "Membership Kit: Build Membership Programs without Expertise, Integrated with Platforms to Grow Communities.",
    image: membershipKitImg,
    type: KindOfKit.MembershipKit,
    tag: ["Membership", "Tier", "Segmentation", "VIP", "Loyalty"],
    path: "/tokenization/create/membership",
    isNew: true,
    supportedNetworkIds: [43161, 43113, 144002],
  },
  {
    title: "Ticket Kit",
    description: "A Digital or Physical Pass for Event Access, with Blockchain Ensuring Fraud Prevention and Transparency.",
    image: ticketKitImg,
    type: KindOfKit.TicketKit,
    tag: ["Ticket", "Event", "Festival", "Pass", "License", "Access"],
    supportedNetworkIds: [43161, 43113, 144002],
  },
  {
    title: "Point Kit",
    description: "Point Kit is an All-in-One Solution to Create and Manage Reward Point Programs, No Blockchain Expertise Needed, to Boost User Engagement.",
    image: pointKitImg,
    type: KindOfKit.PointKit,
    tag: ["Point", "Reward", "Mileage", "Cash", "Credit"],
    supportedNetworkIds: [43161, 43113, 144002],
  },
];
const CUSTOMIZABLE_KITS: KitCard[] = [
  {
    title: "Token Kit",
    description: "Token Kit is a simple solution to create and manage tokens, integrating with various platforms.",
    image: tokenKitImg,
    type: KindOfKit.TokenKit,
    tag: ["Token", "Point", "Payment", "DeFi", "Governance", "Reward"],
    path: "/tokenization/create/token",
    isNew: true,
    supportedNetworkIds: [43161, 43113, 144002],
  },
  // {
  //   title: "NFT Kit",
  //   description: "NFT Kit is a one-stop solution to create and manage NFTs without blockchain expertise, supporting multiple marketplaces.",
  //   image: nftKitImg,
  //   type: KindOfKit.NFTKit,
  //   tag: ["NFT", "Ticket", "Collectibles", "Limited asset", "Property"],
  //   path: "/tokenization/create/nft",
  //   isNew: true,
  //   supportedNetworkIds: [43161, 43113, 144002],
  // },
  // {
  //   title: 'Security Token Kit',
  //   description: 'Security Token Kit is a simple solution to create and manage security tokens, integrating with various platforms.',
  //   image: securityKitImg,
  //   type: KindOfKit.SecurityTokenKit,
  // },
];
const TokenizeMain = () => {
  const navigate = useNavigate();
  return (
    <PageArticle id="TokenizeMain">
      {/*<SelectMethodToAddKitModal*/}
      {/*  isOpen={isSelectKitTypeModalOpen}*/}
      {/*  closeModal={() => setIsSelectKitTypeModalOpen(false)}*/}
      {/*  setIsPublicKitListModalOpen={setIsPublicKitListModalOpen}*/}
      {/*  selectedKitType={selectedKitType}*/}
      {/*/>*/}
      {/*<PublicKitsModal isOpen={isPublicKitListModalOpen} closeModal={() => setIsPublicKitListModalOpen(false)} getMyPublicKits={getMyPublicKits} />*/}
      <PageTitle
        title={"Tokenize"}
        description={"Get started with a pre-configured kit optimized for common needs, or customize your own to fit your unique requirements"}
      />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            padding: 40,
          }}
        >
          <div className="tokenize-notice">
            <div className="tokenize-notice-title">Build Your Own App With Tokenize Kit 💡</div>
            <div className="tokenize-notice-description">
              Easily create and customize apps using pre-configured kits optimized for common scenarios, or build your own unique solution effortlessly.
            </div>
          </div>
          {/* <div className="kit-title">Pre-configured Kit</div>
          <div className="kit-description">Choose from pre-configured kits optimized for common use cases</div>
          <div className="kit-wrapper">
            {PRE_CONFIGURED_KITS.map((kit, index) => (
              <TokenizeKitCard key={index} kit={kit} />
            ))}
          </div>
          <DivideLine style={{ margin: '60px 0 ' }} /> */}
          <div className="kit-title">Customizable Kit</div>
          <div className="kit-description">Customize your development kit to match your unique requirements</div>
          <div className="kit-wrapper">
            {CUSTOMIZABLE_KITS.map((kit, index) => (
              <TokenizeKitCard key={index} kit={kit} />
            ))}
          </div>
        </div>
      </div>
    </PageArticle>
  );
};

export default TokenizeMain;

const TokenizeKitCard = (props: { kit: KitCard }) => {
  const { kit } = props;
  const navigate = useNavigate();
  const supportedNetworks = NETWORKS.filter((network) => kit.supportedNetworkIds.includes(network.id));
  return (
    <div
      className={`kit-card${!kit.path ? " disabled" : ""}`}
      onClick={() => {
        if (kit.path) {
          navigate(kit.path);
        }
      }}
    >
      <div style={{ display: "flex", gap: 8 }}>
        <img src={kit.image} alt="" className="kit-card-image" />
        <div className="kit-card-content-wrapper">
          <div className="kit-card-title-wrapper">
            {kit.isNew ? <TagBadge type={TagBadgeType.YELLOW} text={"NEW"} /> : !kit.path && <TagBadge type={TagBadgeType.Normal} text={"Coming Soon!"} />}
            <div className="kit-card-title">{kit.title}</div>
          </div>
        </div>
      </div>
      <div className="kit-card-description">{kit.description}</div>
      <div className="kit-card-tag-wrapper">
        {kit.tag?.map((tag, index) => (
          <div key={index} className="kit-card-tag">
            #{tag}
          </div>
        ))}
      </div>
      {kit.path && (
        <div className="kit-card-chain-wrapper">
          {supportedNetworks.map((network) => (
            <img src={network.image} alt="Ethereum" className="kit-card-chain" />
          ))}
        </div>
      )}
    </div>
  );
};
